import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Mail18 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={18}
    contrast={contrast}
    className={className}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M1.5 2.25C0.809644 2.25 0.25 2.80964 0.25 3.5V14.5C0.25 15.1904 0.809644 15.75 1.5 15.75H16.5C17.1904 15.75 17.75 15.1904 17.75 14.5V3.5C17.75 2.80964 17.1904 2.25 16.5 2.25H1.5ZM1.75 5.65285V14.25H16.25V5.65282L8.99998 11.9966L1.75 5.65285ZM16.1468 3.75H1.8532L8.99998 10.0034L16.1468 3.75Z'
      fill='currentColor'
    />
  </Svg>
);

Mail18.displayName = 'Mail18';
export default Mail18;
